export const NTT_MAP_BASE_URL =
  process.env.REACT_APP_NTT_MAP_BASE_URL ||
  "https://d2bhiuln606fjb.cloudfront.net";

export const TEPCO_MAP_BASE_URL =
  process.env.REACT_APP_TEPCO_MAP_BASE_URL ||
  NTT_MAP_BASE_URL;

export const HOKUDEN_MAP_BASE_URL =
  process.env.REACT_APP_HOKUDEN_MAP_BASE_URL ||
  "https://d3f00t1qx4rww6.cloudfront.net";

export const HOKUDEN_MAP_BASE_PREFIX =
  process.env.REACT_APP_HOKUDEN_MAP_BASE_PREFIX ||
  "2025";

export const HOKUDEN_MAP_SOURCE_MODE =
  process.env.REACT_APP_HOKUDEN_MAP_SOURCE_MODE ||
  "tile";
// "tile" or "geojson"
